<template>
	<div class="row">
		<div class="col-md-12">
			<customers-datatable
				ref="datatable"
				@reload="reload"
				:project="item"
				:user="user"
				:isAuth="isAuth">
			</customers-datatable>
		</div>
	</div>
</template>

<script>
	import CustomersDatatable from '@/components/customers/views/Datatable.vue'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'customers-datatable': CustomersDatatable,
		},
		data () {
			return {
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
			},
			reload() {
				this.$emit('reload')
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Customers.vue